"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndexedDBService = void 0;
var idb_1 = require("idb");
var uuid_1 = require("uuid");
/**
 * Service class responsible for managing operations related to IndexedDB storage.
 * It provides methods for initializing, clearing, adding, updating and deleting.
 */
var IndexedDBService = /** @class */ (function () {
    function IndexedDBService() {
        this.DB = null;
        this.DBName = "BIEvents";
        this.DBVersion = 1;
        this.StoreName = "BIEventsMessages";
        this.KeyPath = "id";
        this.StoreIndex = "timestamp";
    }
    /**
     * Opens a indexeddb connection with the correct version and store name.
     */
    IndexedDBService.prototype.openDB = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, e_1;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        if (this.DB)
                            return [2 /*return*/];
                        _a = this;
                        return [4 /*yield*/, (0, idb_1.openDB)(this.DBName, this.DBVersion, {
                                upgrade: function (database) {
                                    var store = database.createObjectStore(_this.StoreName, { keyPath: _this.KeyPath });
                                    store.createIndex(_this.StoreIndex, _this.StoreIndex);
                                },
                                terminated: function () {
                                    console.error("DB has terminated unexpectedly");
                                },
                            })];
                    case 1:
                        _a.DB = _b.sent();
                        if (!this.DB)
                            console.error("DB has not initialize");
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _b.sent();
                        console.error("Failed to open indexeddb connection", e_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Initializes the IndexedDB database.
     * Must be initialize before usage.
     */
    IndexedDBService.prototype.initializeDB = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.openDB()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_2 = _a.sent();
                        console.error('DB has not created:', e_2);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Clears all data from the object store.
     */
    IndexedDBService.prototype.clearDB = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_3;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.openDB()];
                    case 1:
                        _b.sent();
                        return [4 /*yield*/, ((_a = this.DB) === null || _a === void 0 ? void 0 : _a.clear(this.StoreName))];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_3 = _b.sent();
                        console.error('DB has not created:', e_3);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Count the amount of BI events in indexeddb.
     */
    IndexedDBService.prototype.countBIEvents = function () {
        return __awaiter(this, void 0, void 0, function () {
            var transaction, numOfRecords, e_4;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.openDB()];
                    case 1:
                        _b.sent();
                        transaction = (_a = this.DB) === null || _a === void 0 ? void 0 : _a.transaction(this.StoreName, "readonly");
                        return [4 /*yield*/, (transaction === null || transaction === void 0 ? void 0 : transaction.store.count())];
                    case 2:
                        numOfRecords = _b.sent();
                        return [2 /*return*/, numOfRecords];
                    case 3:
                        e_4 = _b.sent();
                        console.error('DB has not created:', e_4);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Retrieves a BI event by its key.
     * @param key The BI event key (id).
     * @returns The retrieved BI event or undefined if not found.
     */
    IndexedDBService.prototype.getBIEventByKey = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            var e_5;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.openDB()];
                    case 1:
                        _b.sent();
                        return [4 /*yield*/, ((_a = this.DB) === null || _a === void 0 ? void 0 : _a.get(this.StoreName, key))];
                    case 2: return [2 /*return*/, _b.sent()];
                    case 3:
                        e_5 = _b.sent();
                        console.error('Failed to get BIEvent from the DB:', e_5);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Adds a new BI event to the object store.
     * @param biEvent BI event to add.
     * @returns The key of the BI event added (id).
     */
    IndexedDBService.prototype.addBIEvent = function (biEvent) {
        return __awaiter(this, void 0, void 0, function () {
            var newBIEvent, e_6;
            var _a;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.openDB()];
                    case 1:
                        _c.sent();
                        newBIEvent = __assign(__assign({}, biEvent), (_a = {}, _a[this.KeyPath] = (0, uuid_1.v4)(), _a[this.StoreIndex] = Date.now(), _a));
                        return [4 /*yield*/, ((_b = this.DB) === null || _b === void 0 ? void 0 : _b.add(this.StoreName, newBIEvent))];
                    case 2: return [2 /*return*/, _c.sent()];
                    case 3:
                        e_6 = _c.sent();
                        console.error('Failed to add BIEvent to the DB:', e_6);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Deletes a BI event from the object store by its key (id).
     * @param key The BI event key.
     */
    IndexedDBService.prototype.deleteBIEvent = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            var e_7;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.openDB()];
                    case 1:
                        _b.sent();
                        return [4 /*yield*/, ((_a = this.DB) === null || _a === void 0 ? void 0 : _a.delete(this.StoreName, key))];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_7 = _b.sent();
                        console.error('Failed to delete BIEvent from the DB:', e_7);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Updates an existing BI event in the object store.
     * @param key The BI event key (id) to update.
     * @param newBIEvent Updated BI event message.
     * @returns The updated BI event key (id).
     */
    IndexedDBService.prototype.updateBIEvent = function (key, newBIEvent) {
        return __awaiter(this, void 0, void 0, function () {
            var updatedBIEvent, e_8;
            var _a;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.openDB()];
                    case 1:
                        _c.sent();
                        updatedBIEvent = __assign(__assign({}, newBIEvent), (_a = {}, _a[this.KeyPath] = key, _a[this.StoreIndex] = Date.now(), _a));
                        return [4 /*yield*/, ((_b = this.DB) === null || _b === void 0 ? void 0 : _b.put(this.StoreName, updatedBIEvent))];
                    case 2: return [2 /*return*/, _c.sent()];
                    case 3:
                        e_8 = _c.sent();
                        console.error('Failed to update BIEvent in the DB:', e_8);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Retrieves a specified number of BI event from the beginning of the object store.
     * @param numOfBIEvents Number of BI event to retrieve.
     * @returns An array of BI events.
     */
    IndexedDBService.prototype.retrieveFirstNumOfBIEvents = function (numOfBIEvents) {
        return __awaiter(this, void 0, void 0, function () {
            var BIEvents, transaction, index, cursor, e_9;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 7, , 8]);
                        return [4 /*yield*/, this.openDB()];
                    case 1:
                        _b.sent();
                        BIEvents = [];
                        transaction = (_a = this.DB) === null || _a === void 0 ? void 0 : _a.transaction(this.StoreName, "readonly");
                        index = transaction === null || transaction === void 0 ? void 0 : transaction.store.index(this.StoreIndex);
                        return [4 /*yield*/, (index === null || index === void 0 ? void 0 : index.openCursor())];
                    case 2:
                        cursor = _b.sent();
                        _b.label = 3;
                    case 3:
                        if (!(cursor && BIEvents.length < numOfBIEvents)) return [3 /*break*/, 5];
                        BIEvents.push(cursor.value);
                        return [4 /*yield*/, cursor.continue()];
                    case 4:
                        cursor = _b.sent();
                        return [3 /*break*/, 3];
                    case 5: return [4 /*yield*/, (transaction === null || transaction === void 0 ? void 0 : transaction.done)];
                    case 6:
                        _b.sent();
                        return [2 /*return*/, BIEvents];
                    case 7:
                        e_9 = _b.sent();
                        console.error("Failed to get ".concat(numOfBIEvents, " BIEvents from the DB:"), e_9);
                        return [3 /*break*/, 8];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Deletes a specified number of BI events from the beginning of the object store.
     * @param numOfBIEvents Number of BI events to delete.
     */
    IndexedDBService.prototype.deleteFirstNumOfBIEvents = function (numOfBIEvents) {
        return __awaiter(this, void 0, void 0, function () {
            var BIEvents, e_10;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        return [4 /*yield*/, this.openDB()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.retrieveFirstNumOfBIEvents(numOfBIEvents)];
                    case 2:
                        BIEvents = _a.sent();
                        if (!BIEvents) return [3 /*break*/, 4];
                        return [4 /*yield*/, Promise.all(BIEvents.map(function (BIEvent) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, this.deleteBIEvent(BIEvent.id)];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        e_10 = _a.sent();
                        console.error("Failed to delete ".concat(numOfBIEvents, " BIEvents from the DB:"), e_10);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    return IndexedDBService;
}());
exports.IndexedDBService = IndexedDBService;
//# sourceMappingURL=indexedDBService.js.map